module.exports = __webpack_public_path__ + "static/img/31.b678f80.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/31.png
// module id = YiXs
// module chunks = 1